<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <div v-if="mobile && !isClick" @click="handelClick" class="hasvalue">
      <span>{{ value }}</span>
    </div>
    <el-tooltip
      :disabled="disabledTooltip() || !isedite"
      :content="tooltip"
      placement="top-start"
      v-else
    >
      <el-select
        :disabled="!isedite"
        :style="inputStyle"
        v-model="val"
        :filterable="options.length > 10"
        ref="component"
        :placeholder="lagplaceholder"
        @change="handleChange"
        popper-class="sel"
        :loading="listloading"
        @focus="handelfocus"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item['商品'] ? item['商品'] + '(' + item['余量'] + ')' : ''"
          :value="item['商品']"
          :disabled="item['余量'] == 0"
        />
      </el-select>
    </el-tooltip>
  </div>
</template>

<script>
import _ from 'lodash'
import * as constants from '@/constants'
import * as storage from '@/utils/storage'
import PageModel from '../../models/page'

export default {
  name: 'jtLimitGroup',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    value: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    compWidth: {
      type: String,
      default: '100%',
    },

    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: String,
      default: '',
    },
    colId: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: '',
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      val: this.value == '' ? null : this.value,
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      listloading: false,
      options: [],
      orderId: '',
      inputStyle: {
        width: window.innerWidth > 768 ? this.compWidth : '100%',
      },
      hasFiredEnterEventHandler: false,
      lagplaceholder:
        storage.getItem(constants.LANGUAGE) === '英文'
          ? 'SELECT'
          : storage.getItem(constants.LANGUAGE) === '中英文'
          ? '请选择/SELECT'
          : '请选择',
      isClick: false,
    }
  },
  watch: {
    value(newValue) {
      this.val = newValue
    },
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    async handelfocus() {
      this.listloading = true
      let config = storage.getItem(constants.GLOBAL_CONFIG)
      let colId = this.colId
      let rowId = this.rowId
      let tag = this.tag
      let data = await PageModel.getGoodsList(tag, colId, rowId)
      let goodsList = data.goodsList
      goodsList.push({ id: 0, xGoodsId: 0, 商品: '', 余量: -1 })
      this.options = goodsList
      this.listloading = false
      this.orderId = data.xOldOrderId || 0
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    // handleVisibleChange(visible) {
    //   if (!visible) {
    //     this.$emit('enter')
    //     _.delay(() => this.$emit('datas', null, this.val), 300)
    //   }
    // },
    async handleChange() {
      // this.$emit('enter')
      _.delay(() => this.$emit('datas', null, this.val), 300)
      let obj = _.find(this.options, (item) => item['商品'] == this.val)
      let config = storage.getItem(constants.GLOBAL_CONFIG)
      let { gameId, teamId } = config
      let xOldOrderId = this.orderId
      let colId = this.colId
      let rowId = this.rowId
      let qty = 1
      let xGoodsId = obj.xGoodsId
      let athlete = this.rowId
      let data = await PageModel.orderGoods(
        xOldOrderId,
        xGoodsId,
        gameId,
        teamId,
        athlete,
        qty,
        colId,
        rowId
      )
      this.isClick = false
    },

    async handelClick() {
      let isedite = this.isedite
      let val = this.value
      let colId = this.colId
      let rows = this.rows
      if (isedite) {
        if (_.isEmpty(val)) {
          let obj = _.find(rows, (item) => item[colId].value != '')
          if (obj) {
            let rowId = this.rowId
            let tag = this.tag
            let data = await PageModel.getGoodsList(tag, colId, rowId)
            let goodsList = data.goodsList
            let obj1 = _.find(goodsList, (item) => item['商品'] == obj[colId].value)
            if (obj1) {
              _.delay(() => this.$emit('datas', null, obj[colId].value), 300)
            }
          } else {
            this.isClick = true
          }
        } else {
          let arr = _.filter(rows, (item) => item[colId].value != '')
          if (arr.length > 1) {
            _.delay(() => this.$emit('datas', null, ''), 300)
          } else {
            this.isClick = true
          }
        }
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.sel {
  .el-select-dropdown__wrap {
    max-height: 474px;
  }

  .el-select-dropdown__item.hover {
    background-color: #8cc5ff;
  }
}

.hasvalue {
  border: 1px solid #DCDFE6;
  padding: 5px 15px;
  width: 100%;
  height: 30px;
}
</style>
    